import * as React from "react";
import { MenuItem, Nav, Navbar, NavDropdown, NavItem } from "react-bootstrap";
import * as ReactDOM from "react-dom";
import Cookies from "universal-cookie";
import { strings } from "../../services/Localization";
import { SignInForward, SignOut, Whoami } from "../../services/Login";
import { toast } from "../../utils/Toaster";
declare const constants;
const cookies = new Cookies();
import { ToastContainer } from "react-toastify";
import UserSettingsModal from "./../Users/UserSettingsModal";
export class NavBar extends React.Component<any, any> {
    public portalEl: HTMLElement;
    constructor(props) {
        super(props);
        this.state = {
            EditMode: false,
            ShowUserSettingsModal: false,
            forwardedSignIn: false,
            language: cookies.get("language") ?
                cookies.get("language") : (constants.languages ? constants.languages[0] : ""),
            numMenusVisible: 2,
            originalUser: null,
            profiles: false,
            signedIn: false,
            url : document.URL.includes("/app"),
            user: null,
            userid_name: "",
        };
        this.portalEl = document.createElement("div");
    }

    public async componentWillMount() {
        try {
            const response: any = await Whoami();
            if (response.user) {
                await this.formatName(response.user.userid, "userid_name");
                this.setState({ menu: window.location.pathname });
                await this.formatName(response.loginuserid.split("/")[0], "originalUser");
                this.setState({
                    profiles: response.user.can_list_device_profile || response.user.can_list_service_profile ||
                        response.user.can_list_channel_profile || response.user.can_list_connectivity_profile ||
                        response.user.can_list_roaming_profile || response.user.can_list_qos_profile,
                    signedIn: true,
                    user: response.user,
                });
                this.forwardLoginCheck(response);
            }
        } catch (error) {
            console.log(error);
        }
    }
    public componentDidMount() {
        document.body.insertBefore(this.portalEl, document.body.children[0]);
    }

    public componentWillUnmount() {
        document.body.removeChild(this.portalEl);
    }

    public forwardLoginCheck = async (userData) => {
        try {
            if (this.state.signedIn) {
                const users = userData.loginuserid.split("/");
                if (users.length > 1) {
                    this.setState({forwardedSignIn: true });
                } else {
                    this.setState({ forwardedSignIn: false });
                }
            }
        } catch (error) {
            toast.error(error);
        }
    }

    public UserSettings = async () => {
        this.setState({
            ShowUserSettingsModal: true,
        });
        // try {

        // } catch (error) {

        // }
    }

    public signInForward = async () => {
        try {
            await SignInForward(undefined);
            localStorage.removeItem("currentGroup");
            window.location.href = `welcome.html`;
        } catch (error) {
            console.log(error);
            toast.error(strings.CAN_NOT_RETURN_TO_PARENT);
        }
    }

    public signOut = async () => {
        try {
            await SignOut(this.state.user.userid);

            localStorage.removeItem("currentGroup");
            window.location.href = "/";
        } catch (error) {
            window.location.href = "/";
        }
    }

    public changeLanguage = (event) => {
        cookies.set("language", event.target.id, { path: "/" });
        location.reload();
    }

    public formatName = (userid, LoginType) => {
        const IsEmail = /@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (IsEmail.test(userid)) {
            const userID = userid.substring(0, userid.lastIndexOf("@"));
            console.log(userID);
            this.setState({ [LoginType]: userID });
        } else {
            this.setState({ [LoginType]: userid });
        }
    }

    public ToggleUserSettingsModal = () => {
        this.setState({
            ShowUserSettingsModal: !this.state.ShowUserSettingsModal,
        });
    }

    public checkFlag = (license, bit) => {
        let {user} = this.state;
        if (!user || !user.can_register) {
            user = {
                can_register: false,
            };
        }
        if (license && bit) {
            switch (bit) {
                case 1:
                    // tslint:disable-next-line:no-bitwise
                    return ((license & 0x1) !== 0);
                case 4:
                    // tslint:disable-next-line:no-bitwise
                    return (((license & 0x4) !== 0) && (user.can_register) &&
                    // tslint:disable-next-line:no-bitwise
                    (((license & 0x1) !== 0) || ((license & 0x2) !== 0)));
                case 5:
                    // tslint:disable-next-line:no-bitwise
                    return ((license & 0x8) !== 0);
                case 6:
                    // tslint:disable-next-line:no-bitwise
                    return ((license & 0x10) !== 0);
                default:
                    return false;
            }
        } else {
            return false;
        }
    }

    public render() {

        const portalled = ReactDOM.createPortal(
            (<ToastContainer toastClassName="toast-container"></ToastContainer>),
            this.portalEl,
        );
        return (
            <div>
                {portalled}
                <Navbar fluid className="top_header_desktop">
                    {constants.leftSideLogo ? <a href="/app">
                        <img src={constants.left_logo_file} className="img-left-logo" />
                    </a> : <div className="fake_left_logo"></div>}
                    <div className="top_bar_name_instance_holder">
                        {constants.app_name &&
                            <div className="padding_left_min app_name_holder">
                                {constants.app_name}
                            </div>
                        }
                        {constants.app_name &&
                            <div className="padding_left_min separator_holder">
                                |
                            </div>
                        }
                        {constants.instance_title &&
                            <div className="padding_left_min instance_holder">
                                {constants.instance_title.substring(0, 29)}
                            </div>
                        }
                    </div>

                    <Nav pullRight className="top_header">
                        {constants.languages && constants.languages.length > 1 && (
                        <NavDropdown
                            eventKey={8}
                            title={(<span className="pull-left margin_lang">
                                <img src={`/theme/images/${this.state.language}_flag.png`} className="img_language" />
                                {this.state.language === "en" ? strings.BUTTON_LANG_EN : strings.BUTTON_LANG_ZH}
                            </span>)}
                            id="basic-nav-dropdown"
                            className="shadow_dropdown lang_dropdown">
                            <MenuItem
                                eventKey={8.1}
                                onClick={this.changeLanguage}
                                id="en"
                            >
                                <img src={`/theme/images/en_flag.png`} className="img_language" />
                                {strings.BUTTON_LANG_EN}
                            </MenuItem>
                            <MenuItem
                                eventKey={8.2}
                                onClick={this.changeLanguage}
                                id="zh"
                            >
                                <img src={`/theme/images/zh_flag.png`} className="img_language" />
                                {strings.BUTTON_LANG_ZH}
                            </MenuItem>
                        </NavDropdown>)}
                        {this.state.signedIn && (
                            <NavDropdown
                                eventKey={1}
                                title={this.state.user && this.state.forwardedSignIn ? (
                                    <span className="pull-left margin_lang">
                                        <b id="user_dropdown_item">{this.state.userid_name}</b>
                                        <img
                                            src={"/theme/images/forward_user.png"} className="user_icon" id="user_icon1"
                                        />
                                    </span>) : this.state.signedIn ? (
                                    <span className="pull-left">
                                    <b id="user_dropdown_item">{this.state.userid_name}</b>
                                    {(this.state.user.administrator || this.state.user.customer_admin) ?
                                        <img
                                            src={"/theme/images/admin_user.png"} className="user_icon" id="user_icon2"
                                        /> :
                                        <img src={"/theme/images/user.png"} className="user_icon" id="user_icon2" />
                                    }
                                </span>) : ""}
                                id="basic-nav-dropdown"
                                className="shadow_dropdown width_mobile">
                                {this.state.signedIn && !this.state.forwardedSignIn && (this.state.user.hasOwnProperty("is_organisation") ? 
                                    <MenuItem>
                                        <img src={`/theme/images/user_customer.png`} className="img_user" />
                                        {strings.ADMIN_TYPE_ORGANIZATION}
                                    </MenuItem> : this.state.user.customer_admin ?
                                    <MenuItem>
                                        <img src={`/theme/images/user_customer.png`} className="img_user" />
                                        {strings.ADMIN_TYPE_CUSTOMER}
                                    </MenuItem> : this.state.user.administrator ?
                                    <MenuItem>
                                        <img src={`/theme/images/user_customer.png`} className="img_user" />
                                        {strings.ADMIN_TYPE_USER}
                                    </MenuItem> : this.state.user.is_customer ?
                                    <MenuItem>
                                    <img src={`/theme/images/user_customer.png`} className="img_user" />
                                    {strings.TYPE_CUSTOMER}
                                </MenuItem> :
                                    <MenuItem>
                                        <img src={`/theme/images/user_customer.png`} className="img_user" />
                                        {strings.TYPE_USER}
                                    </MenuItem>
                                )}
                                {this.state.user && this.state.forwardedSignIn &&
                                    <MenuItem className="align-left" eventKey={1.1} >
                                        <img src={`/theme/images/user_customer.png`} className="img_user_forward" />
                                        <div className="forwarded_user">
                                            {strings.NAV_SIGNED_AS} {this.state.userid_name} <br></br>
                                            {strings.formatString(strings.VIA, {
                                                originalUser: this.state.originalUser,
                                            })}
                                            <br></br>
                                        ({this.state.user.customer_admin ?
                                            strings.ADMIN_TYPE_CUSTOMER : strings.ADMIN_TYPE_USER
                                        })
                                    </div>
                                </MenuItem>}
                                {this.state.signedIn &&
                                    <MenuItem
                                        className="align-left user-settings"
                                        eventKey={1.2}
                                        onClick={this.UserSettings}
                                    >
                                        <img src={`/theme/images/settings.png`} className="img_dropdown" />
                                        {strings.NAV_USER_SETTINGS}
                                    </MenuItem>
                                }
                                {this.state.user && this.state.forwardedSignIn &&
                                    <MenuItem className="align-left" eventKey={1.3} onClick={this.signInForward}>
                                        <img
                                            src={"/theme/images/forward_user_dark.png"}
                                            className="user_icon forward_login_icon" />
                                        {strings.formatString(
                                            strings.NAV_RETURN_TO,
                                            { originalUser: this.state.originalUser },
                                        )}
                                    </MenuItem>}
                                <MenuItem className="align-left" divider />
                                {this.state.signedIn &&
                                    <MenuItem
                                        className="align-left user-settings"
                                        eventKey={1.4}
                                        onClick={this.signOut}
                                    >
                                        <img src={`/theme/images/sign-out.png`} className="img_sign_out" />
                                        {strings.SIGN_OUT}
                                    </MenuItem>
                                }
                            </NavDropdown>
                        )}
                        {!this.state.signedIn &&
                            <NavItem className="align-left sign-in" href="/app/signin">
                                {strings.SIGN_IN}
                            </NavItem>
                        }
                        {constants.rightSideLogo &&
                            <NavItem className="right_logo">
                                <div className="img-right-logo">
                                    <img src={constants.right_logo_file} className="img-right-logo-img" />
                                </div>
                            </NavItem>
                        }
                    </Nav>
                </Navbar>

                <Navbar fluid className="main_header_desktop">
                    {this.state.signedIn && <Navbar.Header>
                        <Navbar.Toggle className="pull-left" />
                    </Navbar.Header>}
                    {this.state.signedIn && <Navbar.Collapse className="navbar_padding ">
                        <Nav className={`padding_menu main_header_desktop selected_language_${this.state.language}`}>


                            {constants.dassboardEnabled &&
                                <NavItem
                                    eventKey={5}
                                    href="/mydashboard.html"
                                    className={
                                        this.state.menu === "/mydashboard.html" ?
                                            `active_menu_${this.state.language}_ active_menu_button` : "hover_item"
                                    }
                                >
                                    {strings.NAV_DASHBOARD}
                                </NavItem>
                            }


                            {!this.state.user.hasOwnProperty("is_organisation") && <NavDropdown
                                eventKey={2}
                                title={strings.NAV_DEVICES_ITEM}
                                id="basic-nav-dropdown"
                                className={
                                    this.state.menu === "/mydevices_list.html" ||
                                    this.state.menu === "/data_list.html" ||
                                    this.state.menu === "/mydevices_map.html" ||
                                    this.state.menu === "/mydevices_register.html" ?
                                        `active_menu_${this.state.language}_ active_menu_dropdown` : "hover_"
                                }
                            >
                                <MenuItem
                                    eventKey={2.1}
                                    href="/mydevices_list.html"
                                    className={
                                        this.state.menu === "/mydevices_list.html" ?
                                            `active_menu_${this.state.language} active_menu_item` : "hover_menu"
                                    }
                                >
                                    {strings.NAV_DEVICES_LIST_DEVICES}
                                </MenuItem>
                                <MenuItem
                                    eventKey={2.2}
                                    href="/data_list.html"
                                    className={
                                        this.state.menu === "/data_list.html" ?
                                            `active_menu_${this.state.language} active_menu_item` : "hover_menu"
                                    }
                                >
                                    {strings.NAV_DATA_SHOW_PACKETS}
                                </MenuItem>
                                <MenuItem
                                    eventKey={2.3}
                                    href="/mydevices_map.html"
                                    className={
                                        this.state.menu === "/mydevices_map.html" ?
                                            `active_menu_${this.state.language} active_menu_item` : "hover_menu"
                                    }
                                >
                                    {strings.NAV_DEVICES_MAP}
                                </MenuItem>
                                {this.checkFlag(this.state.user._license, 4) && (
                                    <MenuItem
                                        eventKey={2.4}
                                        href="/mydevices_register.html"
                                        className={
                                            this.state.menu === "/mydevices_register.html" ?
                                            `active_menu_${this.state.language} active_menu_item` : "hover_menu"
                                        }
                                    >
                                        {strings.NAV_DEVICES_BATCH}
                                    </MenuItem>
                                )}
                            </NavDropdown> }

                            {!this.state.user.hasOwnProperty("is_organisation") && <NavDropdown
                                eventKey={2}
                                title={strings.NAV_MANAGE_GROUPS}
                                id="basic-nav-dropdown"
                                className={
                                    this.state.menu === "/manage_groups.html" ||
                                    this.state.menu === "/multicast_activity.html" ?
                                        `active_menu_${this.state.language}_ active_menu_dropdown` : "hover_"
                                }
                            >

                                <MenuItem
                                    eventKey={2.3}
                                    href="/manage_groups.html"
                                    className={
                                        this.state.menu === "/manage_groups.html" ?
                                            `active_menu_${this.state.language} active_menu_item` : "hover_menu"
                                    }
                                >
                                    {strings.NAV_MANAGE_GROUPS_TAB}
                                </MenuItem>
                                <MenuItem
                                    eventKey={2.4}
                                    href="/multicast_activity.html"
                                    className={
                                        this.state.menu === "/multicast_activity.html" ?
                                        `active_menu_${this.state.language} active_menu_item` : "hover_menu"
                                    }
                                >
                                    {strings.GROUP_ACTIVITY_TITLE}
                                </MenuItem>
                            </NavDropdown> }

                            {!this.state.user.hasOwnProperty("is_organisation") && <NavDropdown
                                eventKey={4}
                                title={strings.NAV_APPLICATIONS_ITEM}
                                id="basic-nav-dropdown"
                                className={
                                    this.state.menu === "/my_apps.html" ||
                                    this.state.menu === "/app/active_connections" ||
                                    this.state.menu === "/app/event_log" ?
                                        `active_menu_${this.state.language}_ active_menu_dropdown` : "hover_"
                                }
                            >
                                <MenuItem
                                    eventKey={4.1}
                                    href="/my_apps.html"
                                    className={
                                        this.state.menu === "/my_apps.html" ?
                                            `active_menu_${this.state.language}_ active_menu_item` : "hover_menu"
                                    }
                                >
                                    {strings.MANAGE_APPLICATIONS_NAV_TITLE}
                                </MenuItem>
                                {this.checkFlag(this.state.user._license, 5) && (
                                    <MenuItem
                                        eventKey={4.2}
                                        href="/app/active_connections"
                                        className={
                                            this.state.menu === "/app/active_connections" ?
                                                `active_menu_${this.state.language}_ active_menu_item` : "hover_menu"
                                        }
                                    >
                                        {strings.ACTIVE_CONNECTIONS_NAV_TITLE}
                                    </MenuItem>
                                )}
                                {this.checkFlag(this.state.user._license, 6) && this.state.user.can_access_logs && (
                                    <MenuItem
                                        eventKey={4.2}
                                        href="/app/event_log"
                                        className={
                                            this.state.menu === "/app/event_log" ?
                                                `active_menu_${this.state.language}_ active_menu_item` : "hover_menu"
                                        }
                                    >
                                        {strings.EVENT_LOG_NAV_TITLE}
                                    </MenuItem>
                                )}
                            </NavDropdown> }

                            {this.state.user.can_own_gtw && !this.state.user.hasOwnProperty("is_organisation") &&
                                <NavItem
                                    eventKey={5}
                                    href="/mygateways_list.html"
                                    className={
                                        this.state.menu === "/mygateways_list.html" ?
                                            `active_menu_${this.state.language}_ active_menu_button` : "hover_item"
                                    }
                                >
                                    {strings.NAV_GATEWAYS_ITEM}
                                </NavItem>
                            }

                            {constants.enable_profiles && this.state.profiles && !this.state.user.hasOwnProperty("is_organisation") && (
                                <NavDropdown
                                    eventKey={6}
                                    title={strings.NAV_PROFILES_ITEM}
                                    id="basic-nav-dropdown"
                                    className={this.state.menu === "/app/device_profiles" ||
                                        this.state.menu === "/app/service_profiles" ||
                                        this.state.menu === "/app/connectivity_profiles" ||
                                        this.state.menu === "/app/roaming_profiles" ||
                                        this.state.menu === "/app/qos_profiles" ||
                                        this.state.menu === "/app/channel_profiles" ?
                                        `active_menu_${this.state.language}_ active_menu_dropdown` : "hover_"}
                                >
                                    {this.state.user.can_list_device_profile && (
                                        <MenuItem
                                            eventKey={6.1}
                                            href="/app/device_profiles"
                                            className={this.state.menu === "/app/device_profiles" ?
                                                `active_menu_${this.state.language} active_menu_item` : "hover_menu"}
                                        >
                                            {strings.NAV_DEVICE_PROFILES}
                                        </MenuItem>
                                    )}
                                    {this.state.user.can_list_service_profile && (
                                        <MenuItem
                                            eventKey={6.2}
                                            href="/app/service_profiles"
                                            className={this.state.menu === "/app/service_profiles" ?
                                                `active_menu_${this.state.language} active_menu_item` : "hover_menu"}
                                        >
                                            {strings.NAV_SERVICE_PROFILES}
                                        </MenuItem>
                                    )}
                                    {this.state.user.can_list_connectivity_profile && (
                                        <MenuItem
                                            eventKey={6.3}
                                            href="/app/connectivity_profiles"
                                            className={this.state.menu === "/app/connectivity_profiles" ?
                                                `active_menu_${this.state.language} active_menu_item` : "hover_menu"}
                                        >
                                            {strings.NAV_CONNECTIVITY_PROFILES}
                                        </MenuItem>
                                    )}
                                    {this.state.user.can_list_roaming_profile && (
                                        <MenuItem
                                            eventKey={6.4}
                                            href="/app/roaming_profiles"
                                            className={this.state.menu === "/app/roaming_profiles" ?
                                                `active_menu_${this.state.language} active_menu_item` : "hover_menu"}
                                        >
                                            {strings.NAV_ROAMING_PROFILES}
                                        </MenuItem>
                                    )}
                                    {this.state.user.can_list_qos_profile && (
                                        <MenuItem
                                            eventKey={6.5}
                                            href="/app/qos_profiles"
                                            className={this.state.menu === "/app/qos_profiles" ?
                                                `active_menu_${this.state.language} active_menu_item` : "hover_menu"}
                                        >
                                            {strings.NAV_QOS_PROFILES}
                                        </MenuItem>
                                    )}
                                    {this.state.user.can_list_channel_profile && (
                                        <MenuItem
                                            eventKey={6.6}
                                            href="/app/channel_profiles"
                                            className={this.state.menu === "/app/channel_profiles" ?
                                                `active_menu_${this.state.language} active_menu_item` : "hover_menu"}
                                        >
                                            {strings.NAV_CHANNEL_PROFILES}
                                        </MenuItem>
                                    )}
                                </NavDropdown>
                            )}

                            {this.state.user && (this.state.user.administrator || this.state.user.customer_admin || this.state.user.org_admin) &&
                                <NavDropdown
                                    eventKey={6}
                                    title={strings.FIND}
                                    id="basic-nav-dropdown"
                                    className={
                                        this.state.menu === "/admin_devices.html" ||
                                        this.state.menu === "/admin_users.html" ?
                                            `active_menu_${this.state.language}_ active_menu_dropdown` : "hover_"
                                    }
                                >
                                    {this.state.user.administrator &&
                                        <MenuItem
                                            eventKey={6.1}
                                            href="/admin_devices.html"
                                            className={
                                                this.state.menu === "/admin_devices.html" ?
                                                    `active_menu_${this.state.language} active_menu_item` : "hover_menu"
                                            }
                                        >
                                            {strings.NAV_ADMIN_DEVICES}
                                        </MenuItem>}
                                    {(this.state.user.customer_admin || this.state.user.administrator || this.state.user.org_admin) &&
                                        <MenuItem
                                            eventKey={6.2}
                                            href="/admin_users.html"
                                            className={
                                                this.state.menu === "/admin_users.html" ?
                                                    `active_menu_${this.state.language} active_menu_item` : "hover_menu"
                                            }
                                        >
                                            {strings.NAV_ADMIN_USERS}
                                        </MenuItem>}
                            </NavDropdown>}
                            {this.state.user && (this.state.user.administrator || this.state.user.customer_admin || this.state.user.org_admin) &&
                                <NavDropdown
                                    eventKey={4}
                                    title={strings.ACCOUNTS}
                                    id="basic-nav-dropdown"
                                    className={
                                        this.state.menu === "/users_list.html" ||
                                        this.state.menu === "/customers_list.html" || 
                                        this.state.menu === "/organization_list.html" ?
                                            `active_menu_${this.state.language}_ active_menu_dropdown` : "hover_"
                                    }
                                >

                                    {this.state.user.administrator && !this.state.user.hasOwnProperty("is_organisation") &&
                                        <MenuItem
                                            eventKey={4.1}
                                            href="/users_list.html"
                                            className={
                                                this.state.menu === "/users_list.html" ?
                                                    `active_menu_${this.state.language} active_menu_item` : "hover_menu"
                                            }
                                        >
                                            {strings.NAV_USERS_LIST_USERS}
                                        </MenuItem>}
                                    {this.state.user.customer_admin &&
                                        <MenuItem
                                            eventKey={4.2}
                                            href="/customers_list.html"
                                            className={
                                                this.state.menu === "/customers_list.html" ?
                                                    `active_menu_${this.state.language} active_menu_item` : "hover_menu"
                                            }
                                        >
                                            {strings.NAV_CUSTOMERS_LIST_CUSTOMERS}
                                        </MenuItem>
                                    }
                                    {this.state.user.org_admin &&
                                        <MenuItem
                                            eventKey={4.3}
                                            href="/organization_list.html"
                                            className={
                                                this.state.menu === "/organization_list.html" ?
                                                    `active_menu_${this.state.language} active_menu_item` : "hover_menu"
                                            }
                                        >
                                            {strings.NAV_ORGANIZATION_LIST_USERS}
                                        </MenuItem>}
                                </NavDropdown>
                            }


                            {constants.enterpriseModeEnabled  &&  this.state.user.sys_admin  &&
                                <NavItem
                                    eventKey={5}
                                    href="/configure.html"
                                    className={
                                        this.state.menu === "/configure.html" ?
                                            `active_menu_${this.state.language}_ active_menu_button` : "hover_item"
                                    }
                                >
                                    {strings.NAV_CONFIGURE}
                                </NavItem>
                            }


                        </Nav>
                    </Navbar.Collapse>}
                </Navbar>
                {this.state.ShowUserSettingsModal === true && (
                    <UserSettingsModal
                        ShowModal={this.state.ShowUserSettingsModal}
                        ToggleModal={this.ToggleUserSettingsModal}
                        User={this.state.user}
                        EditMode={this.state.EditMode}
                        ModalTitle={strings.NAV_USER_SETTINGS}
                    />
                )}
            </div>
        );

    }
}
